import { createSlice } from '@reduxjs/toolkit'
import { Wei } from 'types'
import { fetchBrokerInfoAction } from './actions'

export interface BrokerInfo {
  available: Wei
  fee: number // 50 /10000,
  limit: Wei
}

export interface BrokerState {
  brokerInfo: BrokerInfo | undefined
  pending: boolean // fetching broker info
}
const initialState: BrokerState = {
  brokerInfo: undefined,
  pending: false,
}

const brokerSlice = createSlice({
  name: 'broker',
  initialState,
  reducers: {
    clearBrokerInfo(state) {
      state.brokerInfo = undefined
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrokerInfoAction.pending, (state) => {
        state.pending = true
      })
      .addCase(fetchBrokerInfoAction.fulfilled, (state, { payload }) => {
        state.brokerInfo = payload
        state.pending = false
      })
      .addCase(fetchBrokerInfoAction.rejected, (state) => {
        state.pending = false
      })
  },
})

export const { clearBrokerInfo } = brokerSlice.actions

export default brokerSlice.reducer
